import React from 'react';
import styled from 'styled-components';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import SegmentScore from 'ff/debrief/components/segments/SegmentScore';
import ApproachSelector from 'ff/debrief/components/segments/ApproachSelector';
import { useCurrentDebrief, useDebriefApp } from 'ff/debrief/hooks';

interface Props {
    segmentLabel: string;
    score?: number;
}

const SegmentDetailsTitle = (props: React.PropsWithChildren<Props>) => {
    const { selectedSegment } = useDebriefApp();
    const { isScoreModeEnabled } = useCurrentDebrief();

    const hasScore = props.score !== undefined;
    const detailsTitle = isScoreModeEnabled
        ? 'Score Details'
        : 'Maneuver Details';

    const displayApproachSelector =
        !hasScore && !!selectedSegment?.instrumentApproaches?.length;

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
                border: '1px solid #E8E8E8',
                borderRadius: '8px',
                px: 3,
                py: 1,
            }}
        >
            <Stack direction="row" alignItems="center" gap={1}>
                <Title>{props.segmentLabel}</Title>
                {isScoreModeEnabled && hasScore && (
                    <SegmentScore score={props.score} />
                )}
            </Stack>
            <Stack direction="row" alignItems="center" gap={1}>
                {displayApproachSelector && (
                    <Stack
                        direction="row"
                        gap={1}
                        alignItems="center"
                        sx={{ minWidth: '200px' }}
                    >
                        <ApproachLabel>Approach</ApproachLabel>
                        <ApproachSelector />
                    </Stack>
                )}
                {hasScore && <Label>{detailsTitle}</Label>}
            </Stack>
        </Stack>
    );
};

const ApproachLabel = styled.span`
    color: #1c1c1e;
    font-size: 10px;
    line-height: 24px;
`;

const Title = styled(Typography)`
    color: #1c1c1e;
    font-size: 15px;
    line-height: 24px;
`;

const Label = styled.span`
    color: #1c1c1e;
    font-size: 15px;
    font-weight: 700;
    line-height: 24px;
`;

export default SegmentDetailsTitle;
